import styled from 'styled-components';
import { Tag, Drawer, Spin } from 'antd';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    align-items: baseline;
  }

  .ant-drawer-body {
    padding: 0;
  }

  .ant-menu-light {
    background: unset;
  }
`;

export const getSizeByCategory = (metricCount: number) =>
  (metricCount % 2 === 0 ? metricCount : metricCount + 1) * 14;

export const StyledCheckBox = styled.div`
  padding: 2px 0;
  min-width: 300px;
`;

export const TemplateStyledCheckBox = styled.div`
  padding: 2px 0;
  width: 50%;

  .name-wrapper {
    color: rgb(0 0 0 / 88%);
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
    word-break: break-word;
  }
`;

export const MetricDivider = styled.div`
  height: 1px;
  background: #979797;
  opacity: 0.5;
  margin-bottom: 5px;
  width: 96%;
`;

export const StyledLeftPanel = styled.div`
  background: rgb(245 245 245);
  width: 250px;

  .create-metric-box {
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 20px 15px;
    background: #fff;
    margin: 15px;
    display: flex;
    flex-direction: column;
  }

  b {
    font-weight: 500;
  }
`;

export const CheckBoxList = styled.div`
  border: 1px transparent solid;
  width: 100%;
  padding-left: 8px;
`;

export const RowWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const StyledText = styled.div`
  padding: 2px 0;
  font-size: 1.1rem;
  font-weight: 500;
  display: flex;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .ant-menu-light.ant-menu-root.ant-menu-vertical {
    border-inline-end: none;
    border: none;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 0;
  border-left: 1px solid #e5e5e5;
  padding-left: 10px;
  padding-top: 10px;
`;

export const CheckboxWrapper = styled.div<{ count: number }>`
  height: ${({ count }) => `${Math.max(getSizeByCategory(count), 50)}px`};
  display: flex;
  flex-flow: column wrap;
`;

export const TemplateCheckboxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 96%;
`;

export const StyledSPITag = styled(Tag)`
  margin-left: 20px;
  font-size: 1em;
  color: white;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const FlexFill = styled.div`
  flex: 1;
`;

export const CountText = styled.div`
  margin: 0 10px;
  line-height: 2;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 20px;
  font-size: 20px;
  font-weight: 400;

  .ant-input-search-button {
    pointer-events: none;
  }
`;

export const CategoryWrapper = styled.div`
  width: 96%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;

  .activate-button {
    font-size: 16px;
    color: rgb(0 0 0 / 45%);

    &:hover {
      color: #0046ff;
    }
  }

  .create-button {
    height: 20px;
    padding: 0 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #e6edff;
    color: #0046ff;
    font-size: 12px;
    border: none;
    border-radius: 2px;
  }
`;

export const StyledSpin = styled(Spin)`
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
`;
